module.exports = __webpack_public_path__ + "img/jwgl-kbcx-xqkb.cdb95744.png";